module.exports = __webpack_public_path__ + "img/23.57d8d61e.png";